import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
`;

export const Cabecalho = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.espaco.sm};

  h2 {
    font-size: ${({ theme }) => theme.fonte.h3};
    color: ${({ theme }) => theme.cores.ink};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};

  ${media.mobile} {
    flex-basis: 100%;

    button {
      flex: 1;
    }
  }
`;
